export default __webpack_public_path__ + "static/media/idea.40aff916.jpeg";